import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=b7a6b8a0&"
import script from "@/controllers/ap/teacher/login/PasswordReset?v=2.0?vue&type=script&lang=ts&"
export * from "@/controllers/ap/teacher/login/PasswordReset?v=2.0?vue&type=script&lang=ts&"
import style0 from "@/assets/css/main.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports